(function () {
  // IMPORTANT:
  // Put your actual product-grid section handle here.
  // In Dawn it's commonly: "main-collection-product-grid"
  const PRODUCT_GRID_SECTION = "main-collection-product-grid";

  const activeClass = "collection-hero__featured-collection--active";

  function setActiveLink(container, url) {
    const links = container.querySelectorAll(".collection-hero__featured-collection");
    links.forEach((a) => a.classList.remove(activeClass));

    // Mark matching href as active
    const match = Array.from(links).find((a) => {
      try {
        return new URL(a.href, window.location.origin).pathname === new URL(url, window.location.origin).pathname;
      } catch (e) {
        return false;
      }
    });

    if (match) match.classList.add(activeClass);
  }

  function findProductGridRoot(documentRoot) {
    // Try common Dawn selectors first
    return (
      documentRoot.querySelector("#ProductGridContainer") ||
      documentRoot.querySelector("[data-product-grid]") ||
      documentRoot.querySelector(".collection") ||
      null
    );
  }

  async function swapCollectionProducts(targetUrl) {
    const url = new URL(targetUrl, window.location.origin);

    // Ask Shopify for a rendered section only
    const res = await fetch(`${url.pathname}?sections=${PRODUCT_GRID_SECTION}`, {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });

    if (!res.ok) throw new Error(`Failed to load collection section: ${res.status}`);

    const data = await res.json();
    const sectionHtml = data[PRODUCT_GRID_SECTION];

    if (!sectionHtml) {
      throw new Error(
        `Section "${PRODUCT_GRID_SECTION}" not returned. Confirm the section handle matches your theme.`
      );
    }

    const parser = new DOMParser();
    const newDoc = parser.parseFromString(sectionHtml, "text/html");

    const newGridRoot = findProductGridRoot(newDoc);
    const currentGridRoot = findProductGridRoot(document);

    if (!newGridRoot || !currentGridRoot) {
      throw new Error("Could not find product grid container to replace (check selectors).");
    }

    // Replace the grid container
    currentGridRoot.replaceWith(newGridRoot);

    // If your theme has price range/facets scripts tied to the grid,
    // you may need to re-run those initializers here.
  }

  function init(sectionRoot) {
    const filters = sectionRoot.querySelector(".collection-hero__featured-collections");
    if (!filters) return;

    filters.addEventListener("click", async (e) => {
      const link = e.target.closest("a.collection-hero__featured-collection");
      if (!link) return;

      // Allow cmd/ctrl click to open in new tab
      if (e.metaKey || e.ctrlKey) return;

      const href = link.getAttribute("href");
      if (!href || href === "#") return;

      e.preventDefault();

      // optimistic UI
      setActiveLink(filters, link.href);
      sectionRoot.classList.add("is-loading");

      try {
        await swapCollectionProducts(link.href);

        // update URL (so back/forward works)
        window.history.pushState({ collectionUrl: link.href }, "", link.href);
      } catch (err) {
        console.error(err);
        // Fallback to normal navigation if something goes wrong
        window.location.href = link.href;
      } finally {
        sectionRoot.classList.remove("is-loading");
      }
    });

    // Back/forward support
    window.addEventListener("popstate", async (event) => {
      const url = (event.state && event.state.collectionUrl) || window.location.href;
      try {
        await swapCollectionProducts(url);
        setActiveLink(filters, url);
      } catch (err) {
        console.error(err);
      }
    });

    // Initial active state
    setActiveLink(filters, window.location.href);
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".collection-hero").forEach(init);
  });
})();
